<template>
  <label for="price" class="g--label mt-4  mb-1">
    Tags
  </label>
  <p class="text-sm text-gray-800 mb-4">
    Select up to three tags.
  </p>

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 max-w-2xl">
    <div class="flex items-start" v-for="tag in tags">
      <div class="flex items-center h-5">
        <input :id="tag.id" name="fields[tags][]" type="checkbox"
               class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out"
               :value="tag.id"
               v-model="selectedTags"
               @change="handleTagSelection">
      </div>
      <div class="ml-3 text-sm leading-5">
        <label :for="tag.id" 
               class="cursor-pointer font-medium"
               :class="isTagSelected(tag.id) ? 'text-gray-700' : (selectedTags.length >= 3 && !isTagSelected(tag.id) ? 'text-gray-300' : 'text-gray-500')">
          <span class="text-base">{{ tag.emoji }}</span>&nbsp;
          {{ tag.title }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  classItem: {
    type: Object,
    required: true,
  },
});

const selectedTags = ref((props.classItem.tags || []).map(tag => tag.id));
// const selectedTags = ref((props.classItem.tagsIds || []));

const isTagSelected = (tagId) => {
  return selectedTags.value.includes(tagId);
};

const handleTagSelection = () => {
  if (selectedTags.value.length > 3) {
    selectedTags.value.pop(); // Remove the last selected tag if more than 3
  }
  emit('update:tags', selectedTags.value);
};

const tags = ref([]);

const classData = ref({
  ...props.classItem
});

onMounted(() => {
  console.log(props.classItem);
  console.log(classData.value);
  fetchTags();
});

const emit = defineEmits(['update:tags']);
const fetchTags = async () => {
  try {
    const response = await fetch('/api/various/tags');
    const data = await response.json();
    tags.value = data;
  } catch (error) {
    console.error('Error fetching tags:', error);
  }
};

</script>